import { AritoIcon, Button, DialogV2 } from '@/components/custom/erp';
import type { KhoHang } from '@/types/schemas';

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  selectedWarehouse?: KhoHang | null;
  deleteWarehouse: (uuid: string) => Promise<void>;
  refreshWarehouses: () => Promise<void>;
  clearSelection: () => void;
}

export const DeleteDialog = ({
  onClose,
  open,
  selectedWarehouse,
  deleteWarehouse,
  refreshWarehouses,
  clearSelection
}: DeleteDialogProps) => {
  const handleDelete = async () => {
    if (selectedWarehouse?.uuid) {
      try {
        await deleteWarehouse(selectedWarehouse.uuid);
        clearSelection(); // Clear the selected row
        await refreshWarehouses();
        onClose();
      } catch (error) {
        console.error('Error deleting warehouse:', error);
        // You can add error handling here, such as displaying an error message
      }
    }
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Xóa dữ liệu'
      maxWidth='sm'
      disableBackdropClose={true}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
      actions={
        <>
          <Button className='bg-[rgba(15,118,110,0.9)] text-white hover:bg-[rgba(15,118,110,1)]' onClick={handleDelete}>
            <AritoIcon icon={884} marginX='4px' />
            Đồng ý
          </Button>
          <Button onClick={onClose} variant='outline'>
            <AritoIcon icon={885} marginX='4px' />
            Huỷ
          </Button>
        </>
      }
    >
      <p className='min-w-[30vw] p-4 text-base font-medium'>Bạn có chắc chắn xóa không?</p>
    </DialogV2>
  );
};

export default DeleteDialog;
